import axios from '../../axios'

export default {
  getDashboardPresets: function () {
    return axios.get('dashboardpreset')
  }
}



// WEBPACK FOOTER //
// ./src/services/api/DashboardPresetsApi.js